export class ENV {
  static readonly identity_provider = import.meta.env.VITE_IDENTITY_PROVIDER as string;
  static readonly client_id = import.meta.env.VITE_CLIENT_ID as string;
  static readonly identity_server_url = import.meta.env.VITE_IDENTITY_SERVER_URL as string;
  static readonly auth_redirect_uri = import.meta.env.VITE_AUTH_REDIRECT_URI as string;
  static readonly oauth_scopes = import.meta.env.VITE_OAUTH_SCOPES as string;
  static readonly auto_redirect = import.meta.env.VITE_AUTO_REDIRECT === 'true';
  static readonly api_base_url = import.meta.env.VITE_API_BASE_URL as string;
  // Dev-only escape hatch. When VITE_AUTH_ENABLED is 'false' AND this is a dev
  // build, App skips the Entra sign-in so an automated agent can drive the app
  // with no human in the loop. Defaults to enabled; only the literal 'false'
  // disables it. See App.tsx for the dev-build guard.
  static readonly auth_enabled = import.meta.env.VITE_AUTH_ENABLED !== 'false';
}
